// Common translations used across multiple pages (header, footer, etc.)

export default {
  // Header
  header: {
    home: "Beranda",
    company: "Perusahaan",
    sustainability: "Keberlanjutan",
    products: "Produk",
    ourServices: "Layanan Kami",
    inquiryForm: "Formulir Inkuiri",
    language: "Bahasa"
  },
  
  // Footer
  footer: {
    quickLinks: "Tautan Cepat",
    home: "Beranda",
    company: "Perusahaan",
    products: "Produk",
    ourServices: "Layanan Kami",
    sustainability: "Keberlanjutan",
    inquiryForm: "Formulir Inkuiri",
    officeHours: "Jam Kantor",
    mondayFriday: "Senin - Jumat",
    saturday: "Sabtu",
    sunday: "Minggu",
    closed: "Tutup",
    ourCertifications: "Sertifikasi Kami",
    allRightsReserved: "Hak Cipta Dilindungi",
    subsidiaryOf: "Anak perusahaan dari",
    designedBy: "Dirancang oleh"
  }
};